module.exports = __webpack_public_path__ + "img/backgroundLifetime.beb8f0b5.svg";